<template>
    <div
        class="mt-6 flex flex-col-reverse flex-wrap gap-x-2 md:mt-0 md:flex-row md:flex-nowrap"
    >
        <slot></slot>
    </div>
</template>
